var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptySkillSet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "0 0 161 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80.4658,
    cy: 80.5,
    r: 80,
    fill: "#E9ECEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3885_12242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.394 93.5C86.794 95 83.694 96 80.494 96C77.294 96 74.294 95.1 71.694 93.6C67.994 95.3 65.194 98.8 64.694 103L63.594 112.6C63.394 113.8 64.194 115 65.494 115.3C70.194 116.3 75.294 116.8 80.594 116.8C85.894 116.8 90.894 116.3 95.694 115.3C96.894 115.1 97.694 113.9 97.494 112.6L96.394 103C95.894 98.7 93.094 95.2 89.394 93.5Z",
    fill: "#B2B2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.494 89.9C86.6244 89.9 91.594 84.9303 91.594 78.7999C91.594 72.6696 86.6244 67.7 80.494 67.7C74.3637 67.7 69.394 72.6696 69.394 78.7999C69.394 84.9303 74.3637 89.9 80.494 89.9Z",
    fill: "#B2B2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.594 71.4001C117.194 71.4001 114.394 73.7001 113.494 76.8H100.994C100.594 72.6 98.994 68.8 96.394 65.7001L105.194 56.9001C106.294 57.5001 107.494 57.9001 108.794 57.9001C112.894 57.9001 116.194 54.6 116.194 50.5C116.194 46.4 112.894 43.1 108.794 43.1C104.694 43.1 101.394 46.4 101.394 50.5C101.394 51.8 101.794 53 102.394 54.1L93.594 62.9001C90.494 60.4001 86.694 58.7 82.594 58.3V45.8C85.694 44.9 87.994 42.1 87.994 38.7C87.994 34.6 84.694 31.3 80.594 31.3C76.494 31.3 73.194 34.6 73.194 38.7C73.194 42.1 75.494 44.9 78.594 45.8V58.3C74.394 58.7 70.594 60.3001 67.594 62.9001L58.594 54C59.194 52.9 59.594 51.7 59.594 50.4C59.594 46.3 56.294 43 52.194 43C48.094 43 44.794 46.3 44.794 50.4C44.794 54.5 48.094 57.8 52.194 57.8C53.494 57.8 54.694 57.4 55.794 56.8L64.694 65.7001C62.194 68.8 60.494 72.5 60.094 76.7001H47.494C46.594 73.6001 43.794 71.3 40.394 71.3C36.294 71.3 32.994 74.6001 32.994 78.7001C32.994 82.8 36.294 86.1 40.394 86.1C43.794 86.1 46.594 83.8 47.494 80.7001H59.994C60.194 83.3 60.894 85.8 62.094 88.1C62.494 88.8 63.194 89.2 63.894 89.2C64.194 89.2 64.494 89.1 64.794 89C65.794 88.5 66.194 87.3 65.594 86.3C64.394 84 63.794 81.5 63.794 78.8C63.794 69.6 71.294 62.1 80.494 62.1C89.694 62.1 97.194 69.6 97.194 78.8C97.194 81.5 96.594 84 95.394 86.3C94.894 87.3 95.294 88.5 96.194 89C97.194 89.5 98.394 89.1 98.894 88.2C100.094 85.9 100.794 83.5 100.994 80.9001H113.494C114.394 84 117.194 86.3 120.594 86.3C124.694 86.3 127.994 83 127.994 78.9001C127.994 74.8001 124.694 71.4001 120.594 71.4001Z",
    fill: "#B2B2B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3885_12242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(30.4658 23.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySkillSet);
export default __webpack_public_path__ + "static/media/EmptySkillSet.7a322d66882905c8e9b5b88a49e2cabb.svg";
export { ForwardRef as ReactComponent };